module.exports = __webpack_public_path__ + "img/video-primary.270e4c03.png";